import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import Layout from "../components/Layout";
import { api } from "../lib/api";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const kind = params.get("kind");
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    if (!sid) { setStatus("error"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (["expired", "failed"].includes(data.payment_status)) { setStatus("error"); return; }
      } catch { setStatus("error"); return; }
      if (tries++ < 8) setTimeout(poll, 2000); else setStatus("pending");
    };
    poll();
  }, [sid]);

  return (
    <Layout>
      <section className="max-w-lg mx-auto px-6 py-32 text-center">
        {status === "checking" && (<><Loader2 className="mx-auto text-pink-500 animate-spin" size={48} /><h1 className="text-2xl font-bold mt-6">Confirming your payment…</h1></>)}
        {status === "paid" && (kind === "giftcard" ? (<><CheckCircle2 className="mx-auto text-green-500" size={56} /><h1 className="text-3xl font-extrabold mt-6">Gift card sent! 🎁</h1><p className="text-zinc-400 mt-3">Thank you — the gift code is on its way by email. Redeem it at checkout on any booking.</p><Link to="/" className="mt-8 inline-flex bg-pink-600 hover:bg-pink-500 rounded-full px-8 py-3 font-semibold transition-colors">Back home</Link></>) : (<><CheckCircle2 className="mx-auto text-green-500" size={56} /><h1 className="text-3xl font-extrabold mt-6">Booking confirmed!</h1><p className="text-zinc-400 mt-3">Thank you — your slot is locked in. We'll email your confirmation shortly. See you soon!</p><Link to="/" className="mt-8 inline-flex bg-pink-600 hover:bg-pink-500 rounded-full px-8 py-3 font-semibold transition-colors">Back home</Link></>))}
        {status === "pending" && (<><Loader2 className="mx-auto text-pink-500 animate-spin" size={48} /><h1 className="text-2xl font-bold mt-6">Payment processing…</h1><p className="text-zinc-400 mt-3">This is taking a moment. Your booking will confirm automatically.</p></>)}
        {status === "error" && (<><XCircle className="mx-auto text-red-500" size={56} /><h1 className="text-2xl font-bold mt-6">Something went wrong</h1><p className="text-zinc-400 mt-3">We couldn't confirm your payment. Please try booking again.</p><Link to="/book" className="mt-8 inline-flex bg-pink-600 hover:bg-pink-500 rounded-full px-8 py-3 font-semibold transition-colors">Try again</Link></>)}
      </section>
    </Layout>
  );
}

export function PaymentCancel() {
  return (
    <Layout>
      <section className="max-w-lg mx-auto px-6 py-32 text-center">
        <XCircle className="mx-auto text-zinc-500" size={56} />
        <h1 className="text-2xl font-bold mt-6">Payment cancelled</h1>
        <p className="text-zinc-400 mt-3">No worries — your booking wasn't confirmed. You can pick up where you left off.</p>
        <Link to="/book" className="mt-8 inline-flex bg-pink-600 hover:bg-pink-500 rounded-full px-8 py-3 font-semibold transition-colors">Back to booking</Link>
      </section>
    </Layout>
  );
}
